import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class DocumentsRequest extends GenericRequest {

    term;
    page;
    filter;
    document_schema_type_id;
    query_ids;
    document_type_id;
    skipPagination;
    month;
    year;
    show_in_tasks;
    include_only_contractor_workers;
    include_only_company_workers;
    include_only_contractor_machines;
    include_only_company_machines;
    check_monthly;

    constructor(
        page,
        term = '',
        filter = 0,
        document_schema_type_id = null,
        query_ids = {},
        document_type_id = null,
        skipPagination = false,
        month = null,
        year = null,
        showInTasks = false,
        includeCriteria,
        checkMonthly,
    ) {
        super(METHOD_POST, ApiEndpoints.DOCUMENTS);

        this.page = page;
        this.term = term;
        this.filter = filter;
        this.document_schema_type_id = document_schema_type_id;
        this.query_ids = query_ids;
        this.document_type_id = document_type_id;
        this.skipPagination = skipPagination;
        this.month = month;
        this.year = year;
        this.show_in_tasks = showInTasks;
        this.check_monthly = checkMonthly;
        if ( includeCriteria ) {
            this.include_only_contractor_workers = includeCriteria.contractorWorkers;
            this.include_only_company_workers = includeCriteria.companyWorkers;
            this.include_only_contractor_machines = includeCriteria.contractorMachines;
            this.include_only_company_machines = includeCriteria.companyMachines;
        }
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.page ) request.criteria.page = this.page;
        if ( this.term ) request.criteria.term = this.term;
        if ( this.filter && this.filter !== 0 ) request.criteria.document_state_ids = [this.filter];
        if ( this.document_schema_type_id ) request.criteria.document_schema_type_ids = [this.document_schema_type_id];
        if ( this.document_type_id ) request.criteria.document_type_ids = [this.document_type_id];
        if ( this.query_ids ) {
            if ( this.query_ids.machine_id ) request.criteria.machine_id = this.query_ids.machine_id;
            if ( this.query_ids.worker_id ) request.criteria.worker_id = this.query_ids.worker_id;
            if ( this.query_ids.company_id ) request.criteria.company_id = this.query_ids.company_id;
            if ( this.query_ids.company_linked_id ) request.criteria.company_linked_id = this.query_ids.company_linked_id;
            if ( this.query_ids.construction_id ) request.criteria.construction_id = this.query_ids.construction_id;
            if ( this.query_ids.as_subcontracted ) request.criteria.as_subcontracted = this.query_ids.as_subcontracted;
        }
        if ( this.skipPagination ) request.criteria.skip_pagination = this.skipPagination;
        if ( this.month ) request.criteria.month = this.month;
        if ( this.year ) request.criteria.year = this.year;
        if ( this.show_in_tasks ) request.criteria.show_in_tasks = this.show_in_tasks;
        if ( this.include_only_contractor_workers ) request.criteria.include_only_contractor_workers = this.include_only_contractor_workers;
        if ( this.include_only_company_workers ) request.criteria.include_only_company_workers = this.include_only_company_workers;
        if ( this.include_only_contractor_machines ) request.criteria.include_only_contractor_machines = this.include_only_contractor_machines;
        if ( this.include_only_company_machines ) request.criteria.include_only_company_machines = this.include_only_company_machines;
        if ( this.check_monthly ) request.criteria.check_monthly = this.check_monthly;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/documents/ws/DocumentsRequest.js